import { useModals } from "@/features/modals/hooks";
import { useActiveProject } from "@/features/project/ActiveProject";
import { type UpdateOpportunity, updateProject } from "@repo/api";
import { ModalSheet, useToast } from "@repo/ui";
import { useTypesafeActions } from "@repo/utils";

import { getView } from "./getModalView";
import {
  type ReducerState,
  type ReducerStateActions,
  ReducerStateDefault,
  modalReducerStateReducer,
  reducerStateActions,
} from "./reducer";

interface ProjectDetailsModalProps {
  isOpen: boolean;
  closeModal: () => void;
}

export const ProjectDetailsModal = ({
  isOpen,
  closeModal,
}: ProjectDetailsModalProps) => {
  const { updateToast } = useToast();
  const { opportunity } = useActiveProject();
  const { pushModal } = useModals();

  const [state, actions] = useTypesafeActions<
    ReducerState,
    ReducerStateActions
  >(
    modalReducerStateReducer,
    {
      ...ReducerStateDefault,
      title: opportunity?.title,
      cmp: opportunity?.customerMeetingPointBuCode,
      hfb: opportunity?.hfb,
      owner: opportunity?.owner,
      assignedTeam: opportunity?.assignedTeam,
      tags: opportunity?.tags,
    },
    reducerStateActions
  );

  if (!opportunity) {
    return null;
  }

  const update = (newOpportunity: UpdateOpportunity) => {
    return updateProject(newOpportunity, updateToast);
  };

  const view = getView(state, actions, opportunity, update, pushModal);

  return (
    <ModalSheet
      title={view.title}
      visible={isOpen}
      onClose={closeModal}
      onBack={view.onBack}
      footer={view.footer}
    >
      {view.view}
    </ModalSheet>
  );
};
